// Monthly cost / billed / profit for people and resources (issue #2 item 8). All figures are for the current calendar month.
export const WEEKS_PER_MONTH = 4.33;
export const DEFAULT_WEEKLY_HOURS = 40;

const num = (v) => Number(v) || 0;

const withProfit = ({ costMonth, billed, costToProjects }) => {
  const profit = billed - costMonth;
  return { costMonth, billed, costToProjects, profit, margin: billed > 0 ? profit / billed : null };
};

// Person: cost/month = cost rate × weekly hours × 4.33; billed = this month's hours × rate to clients.
export const personCosts = (p) => {
  const rate = num(p.default_hourly_rate);
  const hours = num(p.month_hours);
  const weekly = p.default_weekly_hours == null ? DEFAULT_WEEKLY_HOURS : num(p.default_weekly_hours);
  return withProfit({
    costMonth: rate * weekly * WEEKS_PER_MONTH,
    billed: hours * num(p.bill_rate),
    costToProjects: hours * rate,
  });
};

// Resource: cost/month = running cost; billed = days booked this month × daily rate to clients.
export const resourceCosts = (r) => {
  const billed = num(r.month_booked_days) * num(r.bill_rate_day);
  return withProfit({ costMonth: num(r.running_cost), billed, costToProjects: billed });
};

export const sumCosts = (rows, costsFor) =>
  withProfit(rows.map(costsFor).reduce(
    (acc, c) => ({
      costMonth: acc.costMonth + c.costMonth,
      billed: acc.billed + c.billed,
      costToProjects: acc.costToProjects + c.costToProjects,
    }),
    { costMonth: 0, billed: 0, costToProjects: 0 }
  ));

// "R626k" style figures for summary cards.
export const formatCompact = (symbol, value) => {
  const abs = Math.abs(value);
  const sign = value < 0 ? "−" : "";
  if (abs >= 1e6) return `${sign}${symbol}${(abs / 1e6).toFixed(1).replace(/\.0$/, "")}m`;
  if (abs >= 1e3) return `${sign}${symbol}${Math.round(abs / 1e3)}k`;
  return `${sign}${symbol}${Math.round(abs).toLocaleString()}`;
};
